module.exports = __webpack_public_path__ + "img/earn-trust.9f93d823.svg";